<div>
  <div class="row row--space-between row--valign-center mb--md">
    <div class="vt-search">
      <span class="icon-loupe vt-search-icon"></span>
      <input type="text" autocomplete="off" [value]="searchText" aria-label="Search"
             [placeholder]="'App.Admin.Dashboard.Table.SearchPlaceholder' | translate"
             (input)="onSearch($any($event.target).value)" />
      @if (searchText) {
        <button type="button" class="vt-search-clear" aria-label="Clear" (click)="clearSearch()">
          <span class="icon-x"></span>
        </button>
      }
    </div>
    <div class="vt-actions">
      <button type="button" mat-button class="secondary-button rounded" (click)="export()">
        {{ 'App.Admin.Buttons.Export' | translate }}
      </button>
      @if (hasActiveFilters) {
        <button type="button" mat-button class="secondary-button rounded" (click)="clearFilters(false)">
          {{ 'App.Admin.Buttons.ClearFilters' | translate }}
        </button>
      }
      <button mat-button type="button" (click)="toggleFilters()" aria-label="Filters">
        <span [matBadge]="activeFilterCount" matBadgeSize="small" [matBadgeHidden]="!hasActiveFilters" class="icon-filter hide-text"></span>
      </button>
    </div>
  </div>

  <app-sortable-table
    [columns]="columns"
    [data]="rows"
    [footer]="footerRow"
    [initialSort]="initialSort"
    [emptyMessage]="'App.Admin.Dashboard.Table.NoResults'">

    <ng-template appTableColumn="name" let-row let-isFooter="isFooter">
      @if (isFooter) {
        {{ 'App.Admin.Dashboard.Table.All' | translate:{ count: row.count } }}
      } @else {
        <span class="vt-location-name">
          <span>{{ row.name }}</span>
          @if (!isActive(row.statusId)) {
            <span class="vt-status" [ngClass]="statusClass(row.statusId)">
              {{ statusLabel(row.statusId) | translate }}
            </span>
          }
        </span>
      }
    </ng-template>

    <!-- Composes city/province; the totals row stays blank. -->
    <ng-template appTableColumn="cityProv" let-row let-isFooter="isFooter">
      @if (!isFooter) { {{ row.city }}, {{ row.provinceCode }} }
    </ng-template>

    <!-- Applies direction styling to row and footer values. -->
    <ng-template appTableColumn="diffAbsolute" let-row>
      <span
        [class.vt-pos]="row.diffAbsolute > 0"
        [class.vt-neg]="row.diffAbsolute < 0"
        [class.vt-neutral]="row.diffAbsolute === 0">
        {{ row.diffAbsolute >= 0 ? '+' : '−' }}{{ abs(row.diffAbsolute) | number:'1.0-0' }}
      </span>
    </ng-template>
  </app-sortable-table>

  <app-filter-drawer [filters]="filters" (applyFilters)="applyFilters($event)" (clearFilters)="clearFilters()"></app-filter-drawer>
</div>
